// Per-route <title> and meta description (S6). The router sets them from
// each route's meta after every navigation; a page that knows a better
// title once its data loads (a session, a pack, an invitation) calls
// setPageTitle() itself:
//
//   import { setPageTitle } from "@/kit/pageTitle.js";
//   setPageTitle(sessionTitle(session)); // "Oct 30, 9:47 PM · cloudloop"
//
// Route meta: `title` and `description` are strings or functions of the
// route. Home has no title, so the tab reads just "cloudloop".

export const SITE_NAME = "cloudloop";

export const DEFAULT_DESCRIPTION =
  "Make music together. Record a loop, invite friends, and stack layers live from anywhere.";

// "Log in" -> "Log in · cloudloop"; empty -> "cloudloop".
export function formatTitle(title) {
  const t = typeof title === "string" ? title.trim() : "";
  return t && t !== SITE_NAME ? `${t} · ${SITE_NAME}` : SITE_NAME;
}

// A meta value may be a function of the route (e.g. the session in the URL).
export function resolveMeta(value, route) {
  if (typeof value !== "function") return value;
  try {
    return value(route);
  } catch (e) {
    return null;
  }
}

export function setPageTitle(title) {
  if (typeof document === "undefined") return;
  document.title = formatTitle(title);
}

export function setPageDescription(text) {
  if (typeof document === "undefined") return;
  let tag = document.head.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }
  const t = typeof text === "string" ? text.trim() : "";
  tag.setAttribute("content", t || DEFAULT_DESCRIPTION);
}

// The router's afterEach hook.
export function applyRouteMeta(route) {
  const meta = (route && route.meta) || {};
  setPageTitle(resolveMeta(meta.title, route));
  setPageDescription(resolveMeta(meta.description, route));
}

// router.afterEach(to, from, failure): a failed, aborted or duplicate
// navigation never entered `to`, so the current page keeps the title it
// set (a session's alt name, a pack's title).
export function applyNavigationMeta(to, failure) {
  if (failure) return false;
  applyRouteMeta(to);
  return true;
}
